import { Box } from '@mui/material';
import { diagonalMosaicUri } from '@assets/images';
import React from 'react';

export const DiagonalMosaicImgBg: React.FC = () => (
  <Box
    component="img"
    src={diagonalMosaicUri}
    sx={{
      position: 'absolute',
      top: 0,
      right: 0,
      width: '200px',
      height: 'auto',
      pointerEvents: 'none',
      zIndex: -1,
      maskImage: 'linear-gradient(to bottom, black 30%, transparent 60%)',
      WebkitMaskImage: 'linear-gradient(to bottom, black 30%, transparent 60%)',
    }}
  />
);
